import React from "react";
import Link from "next/link";
import Image from "next/image";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import { mwImage } from "../../../lib/common";

const BlogHeroSectionV2 = ({ leftBlockPostDetails, isCategories, firstImageIsLcp = false }) => {
    const validPosts = (leftBlockPostDetails || []).filter((item) => Boolean(item?.node?.slug));
    return (
        <>
            <div className={"blogs"}>
                <div className={"container"}>
                    <div className={"d-flex"}>
                        {validPosts.map((__item, index)=> {
                            let item = __item?.node
                            if (!item) return null;
                            let link = item.slug;
                            if (item?.parentSlug?.parentSlug != null && item?.parentSlug?.parentSlug.length > 0) {
                                link = item.parentSlug.parentSlug;
                            }
                            const isLcp = firstImageIsLcp && index === 0;

                                return <React.Fragment key={item.uri ?? index}>
                                    <div className={"left-block"}>
                                    <Link href={!isCategories ? `/blog/${link}` : `/whitepaper/${link}`} itemProp="url">
                                        <Image
                                            src={mwImage(item?.featuredImage?.node?.sourceUrl)}
                                            alt={item?.title}
                                            width={400}
                                            height={250}
                                            loading={isLcp ? "eager" : "lazy"}
                                            fetchPriority={isLcp ? "high" : undefined}
                                            unoptimized
                                            sizes="(max-width: 768px) 100vw, 400px"
                                        />
                                    </Link>

                                    </div>

                                    <div className={"right-block"}>
                                        {!isCategories ? <Link href={'/blog/category/' + item.categories.nodes[0].slug + '/?page=1'}
                                                              itemProp="url">
                                            <div className={'category knowledge'}>{item.categories.nodes[0].name}</div>
                                        </Link> : ""}
                                        <Link href={!isCategories ? `/blog/${link}` : `/whitepaper/${link}`} itemProp="url"><h2>{item.title}</h2></Link>
                                        {!isCategories ? <p>{item.subTitle.subTitle}</p> : ""}
                                        <div className={"date-time"}>{dayjs(item?.date).format("D MMM YYYY")}</div>
                                    </div>
                                </React.Fragment>

                        })}


                    </div>
                </div>
            </div>
        </>
    )
}
BlogHeroSectionV2.defaultProps = {
    leftBlockPostDetails:[],
    isCategories: false,
    firstImageIsLcp: false
}
BlogHeroSectionV2.propTypes = {
    leftBlockPostDetails: PropTypes.array.isRequired,
    isCategories: PropTypes.bool,
    firstImageIsLcp: PropTypes.bool
}
export default BlogHeroSectionV2